/**
 * Filter IDs used in the newsfeed widget
 */
export enum NewsfeedFilterIds {
  TYPE_FILTER = 'TypeFilter',
  SOURCE_FILTER = 'SourceFilter',
  SEARCH_FILTER = 'SearchFilter',
  SEARCH_LIKE_FILTER = 'SearchLikeFilter'
}
